import React from "react";
import LoadingGif from '../Assets/Loading/loading.gif'

const Loading = ({ loading, children }) => {
    return (
        <div style={{ position: "relative",height:"100%", width:"100%" }}>
            {loading && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                }}>
                    <img src={LoadingGif} alt="Loading..." style={{ width: "250px", height: "250px" }} />
                </div>
            )}
            {children}
        </div>
    );
}

export default Loading;
